/**
 * Persistência do treinador principal do aluno (localStorage).
 * Quando o aluno tem apenas um treinador, ele é usado automaticamente.
 * Quando tem vários, o aluno escolhe um e podemos trocar pelo menu.
 */

const MAIN_COACH_KEY = 'mainCoachId';

export function getMainCoachId(): number | null {
  if (typeof window === 'undefined') return null;
  const raw = localStorage.getItem(MAIN_COACH_KEY);
  if (raw == null) return null;
  const id = Number(raw);
  return Number.isNaN(id) ? null : id;
}

export function setMainCoachId(id: number): void {
  if (typeof window === 'undefined') return;
  localStorage.setItem(MAIN_COACH_KEY, String(id));
}

export function clearMainCoachId(): void {
  if (typeof window === 'undefined') return;
  localStorage.removeItem(MAIN_COACH_KEY);
}
